import React from 'react';
import { useNavigate } from 'react-router';
import { Box, Button } from '@mui/material';

import { SearchStringProvider, useSearchString } from '@barboxx/admin-utils';

import {
    CustomPageHeader,
    RootContainer,
} from '../../components/nav/RootContainer';
import UserTable from './components/UserTable';

function UserListContainer() {
    const { InputComponent, searchString } = useSearchString();
    const navigate = useNavigate();

    const handleAddClick = React.useCallback(() => {
        navigate('create');
    }, [navigate]);

    const CustomPageToolbarComponent = React.useCallback(
        () => (
            <CustomPageHeader>
                <Box gap={2} flexDirection="row" display="flex">
                    <InputComponent />
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleAddClick}
                    >
                        Add User
                    </Button>
                </Box>
            </CustomPageHeader>
        ),
        [InputComponent, handleAddClick]
    );

    return (
        <RootContainer
            maxWidth={false}
            slots={{
                header: CustomPageToolbarComponent,
            }}
        >
            <UserTable searchString={searchString} />
        </RootContainer>
    );
}

export function UserList() {
    return (
        <SearchStringProvider>
            <UserListContainer />
        </SearchStringProvider>
    );
}
